function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,47.843137%,80%)",
      fillOpacity: 1
    },
    d: "M 4.050781 15 L 4.050781 25.949219 L 25.949219 25.949219 L 25.949219 4.050781 L 4.050781 4.050781 Z M 4.050781 15 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.890625 15.074219 L 8.886719 15.964844 L 11.742188 15.964844 L 11.742188 24.066406 L 13.757812 24.066406 L 13.757812 15.964844 L 16.609375 15.964844 L 16.609375 15.082031 C 16.609375 14.597656 16.597656 14.191406 16.582031 14.179688 C 16.570312 14.164062 14.839844 14.160156 12.738281 14.160156 L 8.910156 14.171875 Z M 8.890625 15.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 21.71875 14.152344 C 22.277344 14.292969 22.699219 14.539062 23.085938 14.945312 C 23.292969 15.160156 23.585938 15.550781 23.609375 15.648438 C 23.617188 15.679688 22.660156 16.3125 22.085938 16.675781 C 22.066406 16.683594 21.984375 16.597656 21.886719 16.457031 C 21.605469 16.050781 21.3125 15.871094 20.863281 15.839844 C 20.195312 15.792969 19.769531 16.140625 19.773438 16.722656 C 19.773438 16.890625 19.800781 16.992188 19.871094 17.128906 C 20.015625 17.429688 20.292969 17.617188 21.136719 17.980469 C 22.703125 18.65625 23.375 19.105469 23.796875 19.734375 C 24.265625 20.441406 24.367188 21.5625 24.046875 22.40625 C 23.699219 23.316406 22.835938 23.933594 21.625 24.136719 C 21.246094 24.203125 20.359375 24.191406 19.957031 24.121094 C 19.074219 23.964844 18.238281 23.53125 17.730469 22.957031 C 17.527344 22.734375 17.136719 22.152344 17.160156 22.109375 C 17.171875 22.097656 17.261719 22.039062 17.363281 21.984375 C 17.460938 21.929688 17.832031 21.714844 18.179688 21.515625 L 18.808594 21.148438 L 18.941406 21.34375 C 19.128906 21.625 19.53125 22.007812 19.769531 22.140625 C 20.464844 22.507812 21.425781 22.457031 21.898438 22.03125 C 22.105469 21.847656 22.1875 21.652344 22.1875 21.378906 C 22.1875 21.125 22.15625 21.011719 22.027344 20.820312 C 21.859375 20.574219 21.511719 20.371094 20.519531 19.945312 C 19.390625 19.457031 18.90625 19.152344 18.457031 18.675781 C 18.199219 18.402344 17.957031 17.953125 17.855469 17.585938 C 17.773438 17.273438 17.753906 16.5 17.820312 16.1875 C 18.054688 15.09375 18.875 14.332031 20.0625 14.113281 C 20.449219 14.035156 21.34375 14.058594 21.71875 14.152344 Z M 21.71875 14.152344 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.ad58bf2103777ba930c915648be09835.svg";
export { ForwardRef as ReactComponent };